import React, { useState, useEffect } from "react"
import { Row, Col, Table } from "reactstrap"
import "react-datepicker/dist/react-datepicker.css"
// import "../../../../../styles/metrics.scss"
import _ from "lodash"
import { useAuth0 } from "@auth0/auth0-react"
import { fetch_get } from "../../../utils/fetch"
import { FaThumbsUp, FaThumbsDown, FaRegEye } from "react-icons/fa"
import { Select, MenuItem } from "@material-ui/core"
import Pagination from "@material-ui/lab/Pagination"
import ModalComponent from "../../../components/modal/modal"
import Jobs from "./pipeline-jobs"

function MetricsProjecCIPipelineTabular (props) {
  const [loadingStatus, setLoadingStatus] = useState({
    loading: false,
    error: false,
    errorMessage: null,
  })
  const [summeryData, setSummeryData] = useState(null)
  const [pageCount, setPageCount] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchCounter, setSearchCounter] = useState(0)
  const { getAccessTokenSilently } = useAuth0()
  const [selectPipeline, setSelectPipeline] = useState({})

  const getSummaryData = () => {
    setLoadingStatus({ loading: true, error: false, errorMessage: null })
    let queryParams = `?page=${currentPage}&limit=${pageSize}&startDate=${props.startDate}&endDate=${props.endDate}&parentOrganization=${props.parentOrg
      }${_.isNil(props.orgIndex) ? "" : `&index=${props.orgIndex}`}`

    getAccessTokenSilently()
      .then(accessToken =>
        fetch_get(`projects/${props.projectSlug}/pipelines${queryParams}`, accessToken)
      )
      .then(response => {
        setSummeryData(response["data"] || [])
        const totalRecords = response["pagination"]["totalRecords"] || 0
        const pageSize = response["pagination"]["pageSize"] || 10
        setPageCount(Math.ceil(totalRecords / pageSize))
        setLoadingStatus({ loading: false, error: false, errorMessage: null })
      })
      .catch(error => {
        setLoadingStatus({ loading: true, error: true, errorMessage: error.message })
      })
  }

  useEffect(() => {
    setCurrentPage(1)
    setSearchCounter(n => n + 1)
  }, [props.counter]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getSummaryData()
  }, [searchCounter])

  function onPageChange (event, page) {
    setCurrentPage(page)
    setSearchCounter(n => n + 1)
  }

  function onPageSizeChange (event) {
    const size = parseInt(event.target.value, 10)
    setPageSize(size)
    setCurrentPage(1)
    setSearchCounter(n => n + 1)
  }

  const showDetail = (item) => {
    setSelectPipeline(item)
    const { rcModal } = props
    rcModal.showModal({
      title: "Job List",
      width: 1200,
      component: (
        <Jobs
          pipeline={item}
          index={props.orgIndex}
          startDate={props.startDate}
          endDate={props.endDate}
          projectSlug={props.projectSlug}
          parentOrg={props.parentOrg}
        />
      ),
    })
  }

  return (
    <>
      {loadingStatus.loading && !loadingStatus.error && (
        <>
          <div className="spinner-grow spinner-grow-sm" role="status"></div> Loading Repos Info..
        </>
      )}
      {!loadingStatus.loading && !loadingStatus.error && summeryData !== null && (
        <>
          {summeryData.length > 0 && (
            <>
              <div className="float-right">
                <div className="form-inline">
                  <Pagination
                    count={pageCount}
                    page={currentPage}
                    onChange={onPageChange}
                    variant="outlined"
                    shape="rounded"
                  />

                  <Select
                    labelId="pageSize"
                    id="page-size"
                    value={pageSize}
                    onChange={onPageSizeChange}
                    className="pageSizeSelect"
                  >
                    <MenuItem value={10}>10 / page</MenuItem>
                    <MenuItem value={50}>50 / page</MenuItem>
                    <MenuItem value={100}>100 / page</MenuItem>
                  </Select>
                </div>
              </div>
              <br />
              <br />
            </>
          )}
          <Row>
            <Col>
              {summeryData.length > 0 && (
                <>
                  <div className="table-border hover">
                    <Table>
                      <thead>
                        <tr>
                          <th>Pipeline ID</th>
                          <th>Status</th>
                          <th>Repository</th>
                          <th>Cost</th>
                          <th>Triggered by</th>
                        </tr>
                      </thead>
                      <tbody>
                        {summeryData.map((item, index) => {
                          return (
                            <tr key={index} style={{ cursor: 'pointer' }} className={selectPipeline.pipeline_id === item.pipeline_id ? "active" : ""} onClick={() => showDetail(item)}>
                              <td><a
                                    target="_blank"
                                    href={item.pipeline_url}
                                    onClick={e => e.stopPropagation()}
                                  >
                                    <FaRegEye />
                                </a>&nbsp;<a className="linkJump handlePointer">{item.pipeline_id}</a></td>
                              <td>
                                {item.pipeline_status === "failed" && (
                                  <>
                                    <FaThumbsDown style={{ fill: "red" }} />
                                    &nbsp;
                                  </>
                                )}
                                {item.pipeline_status === "success" && (
                                  <>
                                    <FaThumbsUp style={{ fill: "green" }} />
                                    &nbsp;
                                  </>
                                )}
                                {_.startCase(item.pipeline_status)}
                              </td>
                              <td className="word-break-all">
                                  <a
                                    target="_blank"
                                    href={item.repo_path}
                                    onClick={e => e.stopPropagation()}
                                  >
                                    {item.repository}
                                  </a>
                                </td>
                              <td>
                                $<strong>{new Number(item.cost).toFixed(2)}</strong>
                              </td>
                              <td>
                                {/* <a
                                  target="_blank"
                                  href={`/metrics/users/${item.trigger_username}/`}
                                > */}
                                {item.triggered_by}
                                {/* </a> */}
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                  </div>
                </>
              )}
              {summeryData.length === 0 && <>Sorry! No Repos found</>}
            </Col>
          </Row>
          {summeryData.length > 0 && (
            <>
              <div className="float-right">
                <div className="form-inline">
                  <Pagination
                    count={pageCount}
                    page={currentPage}
                    onChange={onPageChange}
                    variant="outlined"
                    shape="rounded"
                  />

                  <Select
                    labelId="pageSize"
                    id="page-size"
                    value={pageSize}
                    onChange={onPageSizeChange}
                    className="pageSizeSelect"
                  >
                    <MenuItem value={10}>10 / page</MenuItem>
                    <MenuItem value={50}>50 / page</MenuItem>
                    <MenuItem value={100}>100 / page</MenuItem>
                  </Select>
                </div>
              </div>
              <br />
              <br />
            </>
          )}
        </>
      )}
    </>
  )
}
export default ModalComponent()(MetricsProjecCIPipelineTabular)